import React, { useState } from "react";
import { modalList, MODALS, IModal } from "../../_constants/modal.tsx";

import { Modal } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/index.ts";
import {
  modalDispatcher,
  modalSelector,
} from "../../store/slices/modal-slice.ts";

const ModalElement: React.FC<{ item: IModal }> = ({ item }) => {
  const dispatch = useAppDispatch();
  const { closeTopModal, closeModal, openModal } = modalDispatcher(dispatch);
  const [hasChanges, setHasChanges] = useState<boolean>(false);

  const handleModalStateChanges = () => {
    setHasChanges(true);
  };

  const {
    modalType,
    props: { closeAction, cancelAction, width, ...rest },
  } = item;

  // Ensure width is a number
  const modalWidth = typeof width === "number" ? width : 520;
  const onModalClose = () => {
    const close = () => {
      if (modalType !== MODALS.DUPLICATE_SURVEYS_MODAL) {
        closeModal({ modalType: MODALS.DUPLICATE_SURVEYS_MODAL });
      }
      closeTopModal();
      closeAction?.();
      cancelAction?.();
    };

    if (hasChanges && item.modalType !== MODALS.DUPLICATE_SURVEYS_MODAL) {
      openModal({
        modalType: MODALS.DUPLICATE_SURVEYS_MODAL,
        props: {
          closeAction: item.props.closeAction,
          cancelAction: item.props.cancelAction,
          title: "CLOSE_MODAL",
          message: "ARE_YOU_SURE_YOU_WANT_TO_CLOSE_MODAL_MSG",
          action: () => close(),
          confirmButtonText: "BUTTON_CLOSE_ANYWAY",
          cancelButtonText: "BUTTON_CANCEL",
        },
      });
    } else {
      close();
    }
  };

  const handleModalClose = (modalType: MODALS) => {
    const handleClose = (modalType: MODALS) => {
      closeModal({ modalType });
      closeModal({ modalType: MODALS.DUPLICATE_SURVEYS_MODAL });
    };

    if (hasChanges && modalType !== MODALS.DUPLICATE_SURVEYS_MODAL) {
      openModal({
        modalType: MODALS.DUPLICATE_SURVEYS_MODAL,
        props: {
          closeAction: item.props.closeAction,
          cancelAction: item.props.cancelAction,
          title: "CLOSE_MODAL",
          message: "ARE_YOU_SURE_YOU_WANT_TO_CLOSE_MODAL_MSG",
          action: () => handleClose(modalType),
          confirmButtonText: "BUTTON_CLOSE_ANYWAY",
          cancelButtonText: "BUTTON_CANCEL",
        },
      });
    } else {
      handleClose(modalType);
    }
  };

  // Handle null modalType case
  if (!modalType) {
    return null;
  }

  const ModalComponent = modalList[modalType as MODALS];
  if (!ModalComponent) {
    console.error(`Modal component not found for type: ${modalType}`);
    return null;
  }

  return (
    <Modal
      open
      onClose={onModalClose}
      key={modalType}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ width: modalWidth, outline: "none" }}>
        {React.createElement(ModalComponent, {
          ...rest,
          width: modalWidth,
          closeAction,
          onModalClose,
          handleModalStateChanges,
          handleModalClose,
          modalFormChange: {
            onChange: handleModalStateChanges,
            onSelect: handleModalStateChanges,
          },
        })}
      </div>
    </Modal>
  );
};

function ModalWrapper() {
  const modalState = useAppSelector(modalSelector);
  const modals = modalState.modals || [];

  return (
    <>
      {modals.map((item: IModal) => (
        <ModalElement item={item} key={item.modalType} />
      ))}
    </>
  );
}

export default ModalWrapper;
